import axiosInsAcademy from '@/api/axios-ugems-academy';
import { GET_COURSE_BY_ID } from '@/api/master-data/course-catalog/course-catalog';

export default {
  getCompanyScopes() {
    return axiosInsAcademy.get('/tna/partner/company-scopes');
  },

  // Get all courses for TNA Mitra
  getCourses(params) {
    return axiosInsAcademy.get('/tna/partner/courses/adminmitra', { params });
  },

  // Get course detail - using course-catalog API
  getCourseDetail(id) {
    return GET_COURSE_BY_ID(id);
  },

  // Get mandatoried employees for a course
  getMandatoriedEmployees(courseId, params) {
    return axiosInsAcademy.get(`/tna/partner/courses/${courseId}/mandatoried-employees`, { params });
  },

  // Get submitted participants for a course
  getSubmittedParticipants(courseId, params) {
    return axiosInsAcademy.get(`/tna/partner/courses/${courseId}/submitted`, { params });
  },

  // Search employees to add as participants
  searchEmployees(params) {
    return axiosInsAcademy.get('/tna/partner/employees', { params });
  },

  syncEmployeeOnDemand(nik, params) {
    return axiosInsAcademy.post('/tna/partner/employees/on-demand-sync', { nik }, { params });
  },

  // Add participant to course (POST)
  addParticipant(courseId, data) {
    return axiosInsAcademy.post(`/tna/partner/courses/${courseId}/participants`, data);
  },

  // Delete participant from course (DELETE)
  deleteParticipant(courseId, participantId) {
    return axiosInsAcademy.delete(`/tna/partner/courses/${courseId}/participants/${participantId}`);
  },

  // Submit participants to manager (POST)
  submitParticipants(courseId, data, params) {
    return axiosInsAcademy.post(`/tna/partner/courses/${courseId}/submit-participant-revamp`, data, { params });
  },

  // Get TNA summary statistics
  getSummary(params) {
    return axiosInsAcademy.get('/tna/partner/summary', { params });
  },

  // Download bulk TNA template
  downloadBulkTemplate(params) {
    return axiosInsAcademy.get('/tna/partner/bulk/download-template', {
      params,
      responseType: 'blob'
    });
  },

  // Upload bulk TNA Excel
  uploadBulkTna(formData, params) {
    return axiosInsAcademy.post('/tna/partner/bulk/upload-tna', formData, {
      params,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  downloadTnaMitraTemplate(courseId, params) {
      return axiosInsAcademy.get(`/tna/partner/courses/${courseId}/download-template`, {
          params,
          responseType: 'blob'
      })
  }, 

  uploadTnaMitraFile(courseId, formData, params) {
      return axiosInsAcademy.post(`/tna/partner/courses/${courseId}/upload-participant`, formData, {
          params,
          headers: {
              'Content-Type': 'multipart/form-data'
          }
      })
  }
};
